import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  & p {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #222222;
    margin-bottom: unset;
  }
`;

export const QuestionDiv = styled.div`
  display: flex;
  align-items: center;
  & span {
    margin-right: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    font-family: Mulish;
    display: flex;
    align-items: center;
    color: #222222;
  }
`;

export const CancelButton = styled.button`
  border: 1px solid var(--primary-red-color);
  background-color: #ffffff;
  color: var(--primary-red-color);
  height: 40px;
  width: 100px;
  border-radius: 5px;
  margin-right: 20px;
`;

export const SaveButton = styled.button`
  background-color: var(--primary-red-color);
  color: #ffffff;
  height: 40px;
  width: 100px;
  border-radius: 5px;
  border: none;
`;
